/*
		       FILENAME: default-messages.ts
		          ROUTE: client/src/app/services/messages
	             AUTHOR: ICI/AD
 	               WHAT: BUILT-IN ENGLISH FALLBACKS FOR THE MSG-* SITE MESSAGE KEYS, SO A MISSING DATABASE ROW NEVER RESULTS IN A BLANK ERROR
	                HOW: EXPORTS TWO LOOKUP MAPS CONSUMED BY GENERICSERVICE.MSG() AND BY THE STEP MESSAGE BOX SINK IN LOANAPPLICATION.COMPONENT
	    IMPORTING FILES: none
	  SUBSCRIBING FILES: generic.service, loanapplication.component, notification.service
	   LAST COMMIT DATE: August 7, 2026
*/

// The site messages live in the server's `message` table and are fetched at boot. Anything
// missing from that table used to surface as `undefined` — which, rendered into the step
// message box, is a red rectangle containing nothing but the close icon. These are the
// last-resort defaults so a member always gets a sentence they can act on.
export const DEFAULT_MESSAGES: Record<string, string> =
{
	'MSG-STEP2-FORM-INLINE-ERROR-VALUESNOTCORRECT':
		'Some values on this step need to be corrected before you can continue.',

	'MSG-STEP3-FORM-INLINE-ERROR-APPROXIMATEINTERESTRATE-NOTPOSITIVE':
		'Enter an approximate interest rate greater than 0.',

	'MSG-STEP3-FORM-INLINE-ERROR-ESTMONTHLYTAX-NOTPOSITIVE':
		'Enter estimated monthly taxes greater than 0.',

	'MSG-STEP3-FORM-INLINE-ERROR-ESTMONTHLYHOI-NOTPOSITIVE':
		'Enter estimated monthly homeowners insurance greater than 0.',

	'MSG-STEP3-FORM-INLINE-ERROR-INCORRECTDTIVALUE':
		'We could not calculate the debt-to-income ratio from these values. Please review the income and monthly payment fields.',

	'MSG-STEP3-FORM-INLINE-ERROR-NEEDTOTALINCOMEFORDTI':
		'Enter the total monthly income on Step 2 so the debt-to-income ratio can be calculated.',

	'MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-MISSINGINFOSTEP1':
		'Complete the borrower address on Step 1 before using this tool.',

	'MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-MISSINGINFOSTEP3':
		'Complete the property address on Step 3 before using this tool.',

	'MSG-RIGHTPANEL-BUTTON-TOAST-ERROR-SOMETHINGWENTWRONG':
		'Something went wrong. Please try again in a moment.',
};

// Keyed by the CSS class the emitter asks for, so an emitter that forgets its message still
// produces something readable rather than a bare coloured square.
export const DEFAULT_MESSAGE_BY_CLASS: Record<string, string> =
{
	errorbox: 'Something on this step needs your attention. Please review the highlighted fields and try again.',
	warningbox: 'Please review the highlighted fields before continuing.',
	successbox: 'Saved.',
};

// Shown when an HTTP call fails and the server sent nothing usable.
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';

// Shown when the request never reached the server at all (HttpErrorResponse.status === 0).
export const DEFAULT_OFFLINE_MESSAGE = 'We could not reach the server. Check your connection and try again.';
